import React, { useState } from 'react';
import { FiShoppingCart, FiMenu, FiX } from 'react-icons/fi';

function Header({ setIsCartOpen, getCartItemCount }) {
  // État pour gérer l'ouverture du menu mobile
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-slate-100 sticky top-0 z-[60]">
      <div className="container mx-auto px-4 h-20 flex justify-between items-center">
        
        {/* Logo et Navigation Desktop */}
        <div className="flex items-center gap-12">
          <h1 className="text-2xl font-black tracking-tighter text-slate-900">
            AFRO<span className="text-blue-600">OPTIC</span>
          </h1>          
          
          {/* Menu Desktop : Masqué sur mobile (hidden), affiché sur desktop (md:flex) */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#accueil" className="text-sm font-bold text-slate-500 hover:text-blue-600 transition-colors uppercase tracking-wider">Accueil</a>
            <a href="#products" className="text-slate-600 hover:text-blue-600 font-medium">Boutique</a>
            <a href="#rendez-vous" className="text-slate-600 hover:text-blue-600 font-medium">Rendez-vous</a>
            <a href="#contacts" className="text-slate-600 hover:text-blue-600 font-medium">Contacts</a>
            <a href="#about" className="text-slate-600 hover:text-blue-600 font-medium">À propos</a>
          </nav>
        </div>
        
        {/* Actions (Panier + Bouton Menu Mobile) */}
        <div className="flex items-center gap-4">
          {/* Bouton Panier (Toujours visible) */}
          <button
            onClick={() => setIsCartOpen(true)}
            className="group relative flex items-center gap-2 bg-slate-900 text-white px-5 py-2.5 rounded-full hover:bg-blue-600 transition-all duration-300 shadow-xl shadow-slate-200"
          >
            <FiShoppingCart className="text-lg group-hover:scale-110 transition-transform" />
            <span className="font-bold text-sm hidden sm:inline">Mon Panier</span>
            {getCartItemCount() > 0 && (
              <span className="absolute -top-1 -right-1 bg-blue-500 text-white border-2 border-white rounded-full w-6 h-6 flex items-center justify-center text-[10px] font-bold">
                {getCartItemCount()}
              </span>
            )}
          </button>

          {/* Bouton Mobile : Masqué sur desktop (md:hidden) */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
          >
            {isMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>
        </div>
      </div>

      {/* Menu Mobile Déroulant : Visible uniquement si isMenuOpen est vrai et sur mobile */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-b border-slate-100 animate-fadeIn">
          <nav className="flex flex-col p-4 gap-4">
            <a href="#accueil" onClick={() => setIsMenuOpen(false)} className="text-slate-600 font-medium p-2 hover:bg-slate-50 rounded">Accueil</a>
            <a href="#products" onClick={() => setIsMenuOpen(false)} className="text-slate-600 font-medium p-2 hover:bg-slate-50 rounded">Boutique</a>
            <a href="#rendez-vous" onClick={() => setIsMenuOpen(false)} className="text-slate-600 font-medium p-2 hover:bg-slate-50 rounded">Rendez-vous</a>
            <a href="#about" onClick={() => setIsMenuOpen(false)} className="text-slate-600 font-medium p-2 hover:bg-slate-50 rounded">À propos</a>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;